import { useKrakenMutation } from '@/components/GraphQLClient';
import AddJourneyCompletionReward from '@/hooks/utils/useAddJourneyCompletionReward/AddJourneyCompletionReward.graphql';
import { addJourneyCompletionRewardSchema } from '@/hooks/utils/useAddJourneyCompletionReward/rewards';
import { RewardJourneyType } from '@/types/rewards';

export type AddJourneyCompletionRewardInput = {
  input: {
    accountNumber: string;
    journey: RewardJourneyType;
  };
};

export const useAddJourneyCompletionReward = () => {
  return useKrakenMutation({
    mutation: (_: AddJourneyCompletionRewardInput) =>
      AddJourneyCompletionReward,
    validateFn(response) {
      return addJourneyCompletionRewardSchema.validate(response);
    },
  });
};
